// third-party
import { createSlice } from '@reduxjs/toolkit';
import { getAllUsers, createOrUpdateUser } from 'api/users';
import { dispatch } from '../index';
import { store } from 'store';

const initialState = {
    isLoading: false,
    list: null,
    query: null,
    currentPage: 1,
    rowsPerPage: 10,
    total: 0,
    selected: {
        name: {
            first: null,
            last: null
        },
        email: null,
        active: false,
        _id: null
    }
};

const slice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        setSearchQuery(state, action) {
            state.currentPage = 1; // reset to page 1
            state.query = action.payload;
        },
        setUsers(state, action) {
            state.list = action.payload.data;
            state.total = action.payload.total;
            state.isLoading = false;
        },
        setLoading(state, action) {
            state.isLoading = action.payload;
        },
        setCurrentPage(state, action) {
            state.currentPage = action.payload;
        },
        setRowsPerPage(state, action) {
            state.rowsPerPage = action.payload;
        },
        setSelectedUser(state, action) {
            state.selected = action.payload;
        }
    }
});

// Reducer
export default slice.reducer;

export function searchUsersList(query) {
    return async () => {
        dispatch(slice.actions.setSearchQuery(query));
        await getListUsers();
    };
}

// users list search query
export function fetchAllUsers(background = false) {
    return async () => {
        await getListUsers(background);
    };
}

export function usersCurrentPage(val) {
    return async () => {
        await dispatch(slice.actions.setCurrentPage(val));
        await getListUsers();
    };
}

export function setSelectedDashUser(val) {
    return async () => {
        await dispatch(slice.actions.setSelectedUser(val));
    };
}

export function usersRowsPerPage(val) {
    return async () => {
        dispatch(slice.actions.setRowsPerPage(val));
    };
}

export function createOrUpdateDashUser(data, isFetchList = true) {
    return async () => {
        try {
            const result = await createOrUpdateUser(data);
            if (isFetchList) {
                getListUsers();
            }
            return result;
        } catch (e) {
            throw new Error(e.message);
        }
    };
}

// fetch all users list function
async function getListUsers(background = false) {
    try {
        if (!background) dispatch(slice.actions.setLoading(true));
        const storeData = store.getState();
        const { currentPage, rowsPerPage, query } = storeData.users;

        const users = await getAllUsers({
            perPage: rowsPerPage,
            pageNo: currentPage,
            query
        });
        const invitationFetchedAt = Date.now();
        dispatch(
            slice.actions.setUsers({
                ...users?.data,
                data: (users?.data?.data || []).map((user) => ({ ...user, invitationFetchedAt }))
            })
        );
    } catch (err) {
        console.log(err);
        dispatch(slice.actions.setLoading(false));
        throw new Error(err.message);
    }
}
